import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24d2a820")

_pushScopeId("data-v-24d2a820")
const _hoisted_1 = { class: "temaProgressBarWrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["temaProgressBar", { animated: _ctx.animate }]
    }, [
      _createVNode("div", {
        class: "completedStep",
        style: 'width:' + _ctx.localCompleted + '%; background-color:' + _ctx.color + ';'
      }, null, 4)
    ], 2)
  ]))
})